/**
 * Разбор названия сущности — ОДИН на оба формата и на страж содержимого.
 *
 * `name` — это markdown, уже отрендеренный в HTML, поэтому приходит обёрнутым в блок.
 * Заголовок строится из инлайнового содержимого этого блока: вложить блок целиком
 * значило бы выдать `<h1><p>…</p></h1>`.
 *
 * Функция общая не ради переиспользования, а ради согласованности: пока страж
 * «есть ли что экспортировать» и сборщики решали это по-разному, находились входы,
 * где страж пропускал экспорт, а на выходе оказывался пустой документ.
 *
 * По той же причине здесь же живёт и нормализация разметки: она обязана применяться к
 * названию одинаково в обоих форматах.
 */
import { normalizeFragment } from './normalizeFragment';

export interface ITitleContent {
  /** Инлайновый HTML заголовка; пустая строка, если показывать нечего. */
  html: string;
  /** Видимый текст заголовка. */
  text: string;
}

export function readTitle(name: string, parser: DOMParser = new DOMParser()): ITitleContent {
  // Нормализация здесь, а не у вызывающих: это единственная точка, общая обоим сборщикам
  // и стражу содержимого. Пока она была pdf-локальной, название с картинкой или таблицей
  // давало разный результат — docx мог не выпустить заголовок вовсе, pdf выпускал его с
  // заглушкой.
  const holder = parser.parseFromString(
    `<body>${normalizeFragment(name ?? '', parser)}</body>`,
    'text/html',
  ).body;
  const block = holder.firstElementChild ?? holder;
  const text = (block.textContent ?? '').trim();

  // Признак — видимый текст, а не непустая разметка: «<p><br></p>» разметку имеет,
  // а заголовка в нём нет, и пустой заголовок съел бы уровень у следующего настоящего.
  return text === '' ? { html: '', text: '' } : { html: block.innerHTML, text };
}
